import classes from './workRightAddMenu.module.css';

import { observer } from 'mobx-react-lite';
import UserFieldsRenderer from '../../../UserFieldsRenderer/index';

const WorkRightAddMenuItem = observer(
  ({
    item,
    selectItem,
    setNewSelectItem,
    setFiles,
    isUserFieldsOperation = false,
    disabled = false,
  }) => {
    const commonProps = {
      item,
      selectItem,
      setNewSelectItem,
      disabled,
      isUserFieldsOperation,
      setFiles,
    };

    return (
      <div className={classes.workRightAddMenu_table_row}>
        <div className={classes.workRightAddMenu_table_left}>{item.name}</div>
        <div className={classes.workRightAddMenu_table_right}>
          <UserFieldsRenderer type={item.type} {...commonProps} />
        </div>
      </div>
    );
  },
);

export default WorkRightAddMenuItem;
